import type {
  MemberAccountDetails,
  MemberGeneralInformation,
  MemberIpInformation,
  MemberUserInformation
} from '@library/types/members';
import { filter, values } from 'ramda';
import { CopyToClipboardButton } from '@library/components/buttons';

export interface MemeberProfileCardDataProps {
  cardData:
    | MemberAccountDetails
    | MemberGeneralInformation
    | MemberUserInformation
    | MemberIpInformation
    | undefined;
}

export const MemberProfileCardData = ({
  cardData
}: MemeberProfileCardDataProps) => {
  const cardItems = cardData
    ? filter((cardItem) => !cardItem.isHidden, values(cardData))
    : [];

  return (
    <div className="px-2">
      {cardItems.map((cardItem) => {
        const {
          dataSentryMask = false,
          copyValue,
          className,
          label,
          value
        } = cardItem;
        return (
          <div
            className="text-soClean-120 flex items-start justify-between text-nowrap pb-2"
            key={label}
          >
            <div
              className="text-soClean-180 pr-4 text-sm"
              data-testid={`label-${label}`}
            >
              {label}
            </div>
            <div
              className={`flex min-h-7 overflow-x-scroll text-sm ${className || ''}`}
              data-sentry-mask={dataSentryMask}
              data-testid={label}
            >
              {copyValue && (
                <CopyToClipboardButton
                  btnClassName="mr-2"
                  textCopied={copyValue}
                />
              )}
              {value}
            </div>
          </div>
        );
      })}
    </div>
  );
};
